
<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblCSOTitle}} :: {{ data.InvoiceNo.toString().toUpperCase() + ' >> ' + data.C_Name}}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0" style="padding: 20px 10px 10px 10px !important;padding-bottom:0px !important;max-height: 82vh !important;height: 70vh !important;">
    		<form [formGroup]="formGroup" novalidate>
		        <div fxLayout="row" fxLayoutAlign="start start">
		            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" >
		                <input matInput #hantracoGrossWeight 
		                type="number" 
		                step=".01"
		                name="HantracoGrossWeight" 
		                formControlName="HantracoGrossWeight" 
		                placeholder="{{translations.lblCSOHentracoGrossWeightKg}}"
		                pattern="^[0-9]*\.?[0-9]*$" 
		                [(ngModel)]="orderCustoms.HantracoGrossWeight"
		                (blur)="hantracoGrossWeightChanged(hantracoGrossWeight.value)" 
		                required>
		                <mat-error *ngIf="!formGroupErrors.HantracoGrossWeight.required || !formGroupErrors.HantracoGrossWeight.pattern">
	                        {{translations.msgCSOGrossWeightError}}
	                    </mat-error>
		            </mat-form-field>
		            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
		                <input matInput value="{{orderCustoms.TotalInvoiceValue.toFixed(3)}}" placeholder="{{translations.lblCSOTotalInvoiceValue}}" disabled="disabled">
		            </mat-form-field>
		        </div>
			    <div fxLayout="row" fxLayoutAlign="start start">    
		            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50" >
		                <input matInput value="{{orderCustoms.VectorCustomValue.toFixed(3)}}" placeholder="{{translations.lblCSOVectorsCustomsValue}}" disabled="disabled">
		            </mat-form-field>
		            <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
		                <input matInput value="{{orderCustoms.Factor.toFixed(3)}}" placeholder="{{translations.lblCSOFactor}}" disabled="disabled">
		            </mat-form-field>
		        </div>
		    	</form>
		        <div class="process-text" *ngIf="!articlesLoaded">
		        	{{translations.lblCSOFetchingArticles}}
		        </div>
		        
		    	<div *ngIf="articlesLoaded" style="display:block !important;overflow-x: scroll; overflow-y: hidden;margin-top: 15px;">

			        <mat-grid-list class="order-customs-header" gutterSize="1px" cols="10" rowHeight="50px" style="margin-bottom: 15px !important;">
			        	<mat-grid-tile colspan="2">{{translations.lblCSOArticle}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOCustomCHTarrifCode}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOArticleGrossWeightKg}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOGrossNetPer}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOArticleNetWeightKg}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOCurrency}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOArticleCustomValue}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSONumberOfPackages}}</mat-grid-tile>
			        	<mat-grid-tile>{{translations.lblCSOPackaging}}</mat-grid-tile>
			        </mat-grid-list>	

			        <!-- <form [formGroup]="formGroup" novalidate> -->
			        <mat-grid-list class="order-customs" gutterSize="1px" cols="10" rowHeight="40px" *ngFor="let article of orderCustoms.Articles; let i = index">
						<mat-grid-tile colspan="2" class="article-name">
							<!-- <mat-checkbox checkboxPosition="before">{{article.Article}}</mat-checkbox> -->
							{{article.Article}}
						</mat-grid-tile>
						<mat-grid-tile class="right-align">{{article.CHTariffCode}}</mat-grid-tile>
						<mat-grid-tile>
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput #articleGrossWeight
				                id="{{'txtArticleGrossWeight' + i.toString()}}" 
				                type="number" 
				                min="0.00" 
				                pattern="^[0-9]*\.?[0-9]*$" 
				                name="{{'ArticleGrossWeight_' + i.toString()}}" 
				               	step=".01"
				                [(ngModel)]="orderCustoms.Articles[i].ArticleGrossWeight" 
				                (blur)="articleGrossWeightChanged(articleGrossWeight.value, i)" 
				                (keypress)="appService.onlyPositiveNumber($event)" >
				                <!-- <mat-error *ngIf="!formGroupErrors.ArticleGrossWeight.required || !formGroupErrors.ArticleGrossWeight.pattern">
			                        {{translations.msgCSOArticleGrossWeightError}} 
			                    </mat-error> -->
				            </mat-form-field>
			        	</mat-grid-tile>
						<mat-grid-tile>
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{article.GrossPerNetPercentage}}" disabled="disabled">
				            </mat-form-field>
				        </mat-grid-tile>
						<mat-grid-tile>
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{getDecimal(article.ArticleNetWeight)}}" disabled="disabled">
				            </mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile class="left-align">
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{article.Currency}}" disabled="disabled">
				            </mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile>
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{ getDecimal(article.ArticleCustomValue)}}" disabled="disabled">
				            </mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile>
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput #numberOfPackages 
				                id="{{'txtNumberOfPackages' + i.toString()}}"
				                type="number" 
				                min="0" 
				                step="1"
				                pattern="^[0-9]*\.?[0-9]*$"				            
				                [(ngModel)]="orderCustoms.Articles[i].NumberOfPackages" 
				                (blur)="numberOfPackagesChanged(numberOfPackages.value, i)" 
				                (keypress)="appService.onlyPositiveNumber($event)">
				                <!-- <mat-error *ngIf="!formGroupErrors.NumberOfPackages.required || !formGroupErrors.NumberOfPackages.pattern">
			                        {{translations.msgCSONumberOfPackagesError}}
			                    </mat-error> -->
				            </mat-form-field>
						</mat-grid-tile>
						<mat-grid-tile class="left-align">
							<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{article.Packaging}}" disabled="disabled">
				            </mat-form-field>
						</mat-grid-tile>
					</mat-grid-list>
					<!-- </form> -->
					<mat-grid-list class="order-customs-footer" gutterSize="1px" cols="10" rowHeight="40px">
			        	<mat-grid-tile colspan="3">
			        		<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{translations.lblCSOTotal}}" disabled="disabled">
				            </mat-form-field>
			        	</mat-grid-tile>
			        	<mat-grid-tile>
			        		<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{orderCustoms.SumArticleGrossWeight.toFixed(3)}}" disabled="disabled">
				            </mat-form-field>
				        </mat-grid-tile>
			        	<mat-grid-tile></mat-grid-tile>
			        	<mat-grid-tile>
			        		<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{orderCustoms.SumArticleNetWeight.toFixed(3)}}" disabled="disabled">
				            </mat-form-field>
			        	</mat-grid-tile>
			        	<mat-grid-tile></mat-grid-tile>
			        	<mat-grid-tile>
			        		<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{orderCustoms.SumArticleCustomsValue.toFixed(3)}}" disabled="disabled">
				            </mat-form-field>
			        	</mat-grid-tile>
			        	<mat-grid-tile>
			        		<mat-form-field floatPlaceholder="never" class="mr-24" fxFlex.xs="100" fxFlex="100" >
				                <input matInput value="{{orderCustoms.SumNumberOfPackages.toFixed(3)}}" disabled="disabled">
				            </mat-form-field>
			        	</mat-grid-tile>
			        	<mat-grid-tile></mat-grid-tile>
			        </mat-grid-list>

		        </div>
    </div>

     <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="right">
        <button mat-raised-button color="accent" (click)="save()" aria-label="SAVE"  fxFlex="47">
            {{translations.lblCSOSave}}
        </button>
        <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
        	{{translations.lblCSOCancel}}
        </button>
    </div>
</div>    


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/order-customs-form/order-customs-form.component.html